export default "__VITE_ASSET__CpkcS$A2__"